<template>
  <div v-if="show" style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast tm-slider-function-modal" @blur="closeModal">
    <div class="uk-modal-dialog" v-click-outside="closeModal">
      <!--кнопка закрытия модалки-->
      <button class="uk-close uk-close-large uk-modal-close-outside" type="button" data-uk-close @click="closeModal()"></button>
      <div class="uk-modal-header">
        <div class="uk-position-relative uk-width-xxlarge" style="overflow-y: auto;">
          <!--заголовок-->
          <h4 class="uk-text-bold">
            <button type="button"
                    @click="copyLink(function_name)"
                    style="padding: 0 5px;"
                    class="uk-icon uk-link-text" data-uk-tooltip="title: Копировать ссылку">
              <md-icon>content_copy</md-icon>
            </button>
            {{ name }}
          </h4>
        </div>
      </div>
      <div class="uk-modal-body">
        <!--описание-->
        <div v-html="prepareText(text)" class="uk-margin" v-if="text"></div>
        <!--кнопка на видео инструкцию-->
        <div class="uk-text-center uk-margin-top uk-grid uk-grid-small uk-flex-center tm-dialog-buttons">
          <template v-if="Array.isArray(video)">
            <div v-for="(current_video, key) in video" :key="key">
              <md-button
                  v-if="current_video" class="md-button md-succes uk-width-1-1"
                  target="_blank"
                  :href="current_video">
                {{ $parent.local_page_keys.button_instruction }}
                <span class="material-icons uk-margin-small-left">play_circle_outline</span>
              </md-button>
            </div>
          </template>
          <template v-else>
            <div>
              <md-button
                  v-if="video" class="md-button md-succes uk-width-1-1"
                  target="_blank"
                  :href="video">
                {{ $parent.local_page_keys.button_instruction }}
                <span class="material-icons uk-margin-small-left">play_circle_outline</span>
              </md-button>
            </div>
          </template>
        </div>
        <!--выводим фото "ДО" из галереи-->
        <div class="uk-grid uk-child-width-1-3 uk-flex-center tm-example-imgs uk-margin-medium-top" data-uk-grid>
            <div v-for="(item, i) in items" :key="i">
              <a class="uk-background-muted uk-flex uk-flex-center uk-flex-column uk-flex-middle uk-text-center" href="#" @click="examples(i)">
                <div class="uk-inline-clip uk-transition-toggle">
                  <img :src="item.src_before" alt="">
                  <img class="uk-transition-fade uk-position-cover" :src="item.src_after" alt="">
                </div>
              </a>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      local_page_keys: null,
    };
  },
  props: {
    name: String,
    function_name: String,
    text: String,
    show: Boolean,
    prevOrderBlock: Boolean,
    video: [Array, String, Object],
    items: {type: [Array, Object]},
    showDialogFaceValue: {type: [Array, Object]},
  },
  methods: {
    closeModal() {
      this.$emit('hide', {showDialog:true});
    },
    examples(i) {
      this.$parent.$data.currentExampleCarouselIndex = i;
      this.$parent.showDialog6 = true;
      this.$parent.prevOrderBlock = this.prevOrderBlock === true;
      this.$parent.parent_function_obj = {
        showDialogFaceValue:this.computeShowDialogFaceValue,
        showDialog:true,
      };

      this.$parent.showDialog = false;
    },
    copyLink(functionName) {
      if (functionName) {
        const targetURL = window.location.protocol + '//' + window.location.host + '/new_mvp/functions_description#' + 'order_' + functionName;
        const input = document.createElement('input');
        input.value = targetURL;
        document.body.appendChild(input);
        input.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(input);
        if (successful) {
          UIkit.notification({
            message: this.local_page_keys.link_copied,
            pos: 'top-center',
            status: 'success',
            timeout: 1500
          })
        }
      }
    },
    prepareText(text) {
      function replaceTextWithLink(text) {
        const linkRegex = /https:\/\/\S+/g;
        return text.replace(linkRegex, (match) => {
          return `<a href="${match}" target="_blank">${match}</a>`;
        });
      }
      return replaceTextWithLink(text);
    }
  },
  async mounted() {

    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('functions_elements'));
  },
  computed:{
    computeShowDialogFaceValue(){
      return this.showDialogFaceValue;
    }
  },
  watch: {
    show: {
      handler(v) {
        if (v) {
          document.documentElement.classList.add('uk-modal-page');
        } else {
          document.documentElement.classList.remove('uk-modal-page');
        }
      }
    },
  }
}
</script>
<style>
  .tm-example-imgs a {
    height: 300px;
  }
  .tm-slider-function-modal > div {
    width: 1000px;
  }
</style>